import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import swal from 'sweetalert';
import { Table, Button, FormGroup } from 'react-bootstrap';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import Inputmask from 'inputmask';
import RaisedButton from 'material-ui/RaisedButton';

import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {Typeahead} from 'react-bootstrap-typeahead';

var Config = require('../../../config');

class PetitionPlasmaticForm extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.addProduct = this.addProduct.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);

		this.state = {
			date_form : "",
			hour: "",
			health_facilities:[],
			requested_by:"",
			requested_to:"",
			user:"",
			user_id:"",
			observations:"",
			
			status:"",

			requestedSelected:[],
			indice:-1,

			requested2Selected:[],
			indice2:-1,


			isLoading: false,
			req_by:null,
			req_to:null,

			products:[],
			loading_product:false,
			product_selected:[],
			index_product:-1,
			valid_prod:"",

			plasmatic_product_id:"",
			amount:"",
			tbl_products:[],
		}
	}

	componentDidMount(){

		if (this.props.match.params.id !== undefined) {
			this.getHealthFacilities();
			//editar
			//traer los datos del pedido
			fetch(Config.default.apiGateway.URL+'plasmatic_product_request/'+this.props.match.params.id,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(res => {
		        if(res.ok){
		          return res.json();
		        }else{
		          res.text().then(function(result) {
		            swal('¡Error', result, 'error');
		          });
	        }})
			.then(response => {
				if(response !== undefined){
					this.setState({
						requested_to:response.request.request_to,
				      	hour:moment(response.request.hour, 'H:mm:ss').format('HH:mm'),
				      	status:response.request.status,
				      	date_form : moment(response.request.date).format('YYYY-MM-DD'),
				      	user_id:response.request.user_request_id,
				    });

				    var index = this.state.health_facilities.findIndex(obj =>
						obj.id === response.request.request_to
					)

					if(index !== -1){
						this.setState({
							indice2:index,
							requested2Selected:[this.state.health_facilities[index]],
						});
					}

					for(var i = 0; i < response.detail.length; i++){
						var obj = {
							plasmatic_product_id: response.detail[i].product.id,
							name: response.detail[i].product.name,
							amount:response.detail[i].detail.amount,
							observations: response.detail[i].detail.observations,
							plasmatic_product_request_id:response.detail[i].detail.plasmatic_product_request_id,

						}

						this.setState({ tbl_products: [...this.state.tbl_products, obj]});
					}
				}
					
			});

		}else {

			//fecha y hora
			fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
				method: 'get',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(res => {
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(result) {
	                swal('¡Error', result, 'error');
	              });
	            }})
			.then(response => {
				var aux = response.split('|');
				
				var hours = this.getHourFormat(aux[1]);
				var aux_date = new Date();

				this.setState({
					date_form : aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
					hour:hours,
				});
			});

			this.getHealthFacilities();
		}

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		//obtener usuario
		var user = JSON.parse(sessionStorage.getItem('medical_staff'));

		var name = ""
		if (user.names) {name += user.names};
		if (user.lastname1) {name += ' '+user.lastname1};
		if (user.lastname2) {name += ' '+user.lastname2};


		this.setState({
			user :  name,
			requested_by:sessionStorage.getItem('health_facilities_id'),
		});		

		this._typeahead_by.getInstance().setState({
			text:sessionStorage.getItem('health_facilities_name')
		});

		fetch(Config.default.apiGateway.URL+'plasmatic_product', {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({products:response});
			}
		});
	}

	//get healt facilities
	getHealthFacilities(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      health_facilities: response
		    });
			
			for (var i = 0; i < response.length; i++) {
				
				if (response[i].id === this.state.requested_by) {
					this.setState({
						indice:i,
						requestedSelected: [response[i]],
					});
					
				}

				if (response[i].id === this.state.requested_to) {
					this.setState({
						indice2:i,
						requested2Selected: [response[i]],
					});
				}
			}	
		});
	} 

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;

		this.setState({
			[campo] : e.target.value
		});

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}	
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'product'){
        		this.setState({loading_product:true});

        		setTimeout(()=>{
        			this.setState({
						index_product:0,
						product_selected:values,
						amount:1,
						loading_product:false,
						plasmatic_product_id:values[0].id,
						valid_prod: ''
				    });

				    this._typeahead_product.getInstance().blur();
				    document.getElementById('amount').focus();

				    this.errorAutoComplete('product');
        		}, 1000);
	        		
        	}else{
        		this.setState({
		            [name]: values[0].id
		        });

		        if (name === 'requested_by') {
		        	this.setState({
						indice:0,
						requestedSelected:values,
				    });
		        };

		        if (name === 'requested_to') {
		        	this.setState({
						indice2:0,
						requested2Selected:values,
				    });
		        };
		        document.getElementById('date_form').focus();
        	}
        }
    }

    _handleSearch = (query) => {
	    this.setState({
			indice:-1,
			requestedSelected:[],
	    });
	}

	_handleSearch2 = (query) => {
	    this.setState({
			indice2:-1,
			requested2Selected:[],
	    });
	}

	
	addProduct(e){
  		if(this.validate('details')){

  			var index = this.state.tbl_products.findIndex(obj => 
  				obj.plasmatic_product_id === this.state.plasmatic_product_id
  			);

  			if(index === -1){
  				this.setState({
	  				tbl_products:[
	  					...this.state.tbl_products,
	  					{
	  						plasmatic_product_id:this.state.plasmatic_product_id,
	  						name:this.state.product_selected[0].name,
							amount:this.state.amount,
							observations:this.state.observations,
	  					}
	  				],

	  				plasmatic_product_id:"",
					amount:"",
					observations:"",
					loading_product:false,
					product_selected:[],
					index_product:-1,
					valid_prod:"",
	  			});
  			}else{
  				swal('Error', 'El producto ya se encuentra agregado', 'error');
  			}

	  			
  		}else{
  			swal('Error', 'Campos Incompletos', 'error');
  		}
  	}


	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null){
    					form.elements[index + 1].focus();
    				}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 3].focus();
    				}
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	removeUnitFromList = (indice) => {
		
		var array = [...this.state.unitsAdded];
		array.splice(indice, 1);
		this.setState({unitsAdded: array});
		
	}

	onSave(tipo){
		if(this.isValidDate(this.state.date_form)){
			if(this.validate('petition')){
				var object = {};
				object.request_to = this.state.requested_to;

				var date = moment(this.state.date_form.split('-').reverse().join('/'), 'DD-MM-YYYY');
				var hour = moment(this.state.hour, 'h:mm a');

				object.date = date.format('MM-DD-YYYY');
				object.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');

				var temp = [];
				for (var i = 0; i < this.state.tbl_products.length; i++) {
					var comp = {};
					comp.plasmatic_product_id = this.state.tbl_products[i].plasmatic_product_id;
					comp.amount = parseInt(this.state.tbl_products[i].amount);
					comp.observations = this.state.tbl_products[i].observations;
					if(this.state.tbl_products[i].plasmatic_product_request_id !== undefined){
						comp.plasmatic_product_request_id = this.state.tbl_products[i].plasmatic_product_request_id;
					}
					temp.push(comp);
				};

				object.plasmatic_product_req_details = temp;
				
				if(object.plasmatic_product_req_details.length === 0){
					swal('Error', 'Tabla incompleta, debe de ingresar por lo menos un componente sanguíneo', 'error');
				}else{

					//validar si es crear o actualizar
					if (this.props.match.params.id !== undefined) {//actualizar
						object.id = parseInt(this.props.match.params.id);
						object.status = tipo === 'enviar' ? 'ENVIADO' : 'PENDIENTE'  ;
						object.user_request_id = this.state.user_id;
						
						this.waiting_modal.handleShow('Guardando...');
						fetch(Config.default.apiGateway.URL+'plasmatic_product_request/'+this.props.match.params.id,{
							method:'PUT',
							body: JSON.stringify(object),
							headers: new Headers({
								'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
								'Accept'		: 'application/json',
								'Content-Type'	: 'application/json'
							})
						}).then(res =>{
							this.waiting_modal.handleClose();
							if(res.ok){
								return 'ok';
							}else{
								res.text().then(function(result){
									swal("Error", result, 'error');
								});
							}
						}).then(response=>{
							if(response !== undefined){
								notify.show("Registro actualizado correctamente.", 'success');

								setTimeout(()=>{
									this.props.history.push('/petition_plasmatic_products');
								}, 1500);

							}
						})
					} else{//crear
						object.status = tipo === 'enviar' ? 'ENVIADO' : 'PENDIENTE';

						fetch(Config.default.apiGateway.URL+'plasmatic_product_request',{
							method:'post',
							body: JSON.stringify(object),
							headers: new Headers({
								'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
								'Accept'		: 'application/json',
								'Content-Type'	: 'application/json'
							})
						}).then(res =>{
							this.waiting_modal.handleClose();

							if(res.ok){
								return 'ok';
							}else{
								res.text().then(function(result){
									swal("Error", result, 'error');
								});
							}
						}).then(response=>{
							if(response !== undefined){
								swal("Correcto", "Registro guardado correctamente.", 'success');
								this.props.history.push("/petition_plasmatic_products");
							}
						})
					};
				}
					
			}else{
				swal("¡Error!", "Campos Incompletos", 'error');
			}
		}else{
			notify.show('Error, Fecha no válida','error');
		}
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	getValidationState(name) {
		const length = this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='requested_by'){
				this.setState({req_by:'error'});
				isFormValid = false;
			}else{
				this.setState({req_to:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='requested_by'){
				this.setState({req_by:''});
			}else{
				this.setState({req_to:''});
			}
		}

		return isFormValid;

	}

	onCancel(){
		this.props.history.push("/petition_plasmatic_products");
	}

	removeUnitFromList = (indice) => {
		var array = [...this.state.tbl_products];
		array.splice(indice, 1);
		this.setState({tbl_products: array});
	}

	errorAutoComplete(name){
		const length = name === 'product' ? this.state.plasmatic_product_id.length :
						name === 'provider' ? this.state.provider_selected.length :  this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='product'){
				this.setState({valid_prod:'error'});
				isFormValid = false;
			}else if(name==='provider'){
				this.setState({valid_prov:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='product'){
				this.setState({valid_prod:''});

			}else if(name==='provider'){
				this.setState({valid_prov:''});
			}

			
		}
	
		return isFormValid;
	}

	validate(section){
  		const select = document.querySelector('div.'+section);
   		const inputs = select.querySelectorAll('input');
   		let isFormValid = true;

   		inputs.forEach(input => {
	    	if(input.required){

    			if(input.id === 'product'){
	    			isFormValid = this.errorAutoComplete(input.id);
	    		}else if(input.id === 'provider'){
	    			isFormValid = this.errorAutoComplete(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}   
		  	}
	    });
	    
	    return isFormValid;
  	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12"style={{paddingTop:"10px"}}>
				<div className="col-xs-12">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Nueva Petición 
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12 petition">
						<div className="col-xs-12 col-sm-3">
							<FormGroup id="req_by" validationState={this.state.req_by} style={{marginBottom:"0px"}}>
								<span className="span-min">Centro Peticionario</span>
								
								<AsyncTypeahead
						          	/*{...this.state}*/
						          	labelKey={(option) => `${option.name}`}
						          	minLength={0}
						          	inputProps={{
						          		name:"requested_by",
						          		required:true,
						          		id:"requested_by",
						          		autoComplete:'off'
						          	}}
						          	id="requested_b"
						          	disabled={true}
						          	options={this.state.health_facilities}
						          	onChange={this.handleTypeAheadChange('requested_by')}
						          	onSearch={this._handleSearch}
						          	defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
						          	selected={this.state.requestedSelected}
						          	ref={ref => this._typeahead_by = ref}
						          	useCache={false}
						          	isLoading={this.state.isLoading}
						          	delay={600}
						          	paginationText="Mostrar mas resultados..."
						        />
						    </FormGroup>
						</div>


						<div className="col-xs-12 col-sm-3">
							<FormGroup id="req_to" validationState={this.state.req_to} style={{marginBottom:"0px"}}>
								<span className="span-min">Centro Distribuidor</span>
								<AsyncTypeahead
						          	/*{...this.state}*/
						          	labelKey={(option) => `${option.name}`}
						          	minLength={0}
						          	inputProps={{
						          		name:"requested_to",
						          		required: true,
						          		id:"requested_to",
						          		autoComplete:'off'
						          	}}
						          	id="requestedTo"
						          	options={this.state.health_facilities}
						          	onChange={this.handleTypeAheadChange('requested_to')}
						            onSearch={this._handleSearch2}
						          	defaultSelected={this.state.health_facilities.slice(this.state.indice2, 1)}
						          	selected={this.state.requested2Selected}
						          	ref={ref => this._typeahead = ref}
						          	useCache={false}
						          	isLoading={this.state.isLoading}
						          	delay={600}
						          	paginationText="Mostrar mas resultados..."
						        />
						    </FormGroup>
						</div>


						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Fecha Petición</span>
							<input className="form-control hour-input" name="date_form" id="date_form" type="date" value={this.state.date_form || ""} 
									onChange={this.handleChange} ref={(input) => { this.inputRef = input }} onKeyPress={(e) => this.validateInput(e)} required />
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Hr Petición</span>
							<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
								data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
								required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
						</div>

						<div className="col-xs-12 col-sm-2">
							<div className="col-xs-12 col-sm-12">
								<span className="span-min">Usuario Solicita</span>
								<input className="form-control" disabled name="user" id="user" 
									value={ this.state.user } 
									onKeyPress={(e) => this.validateInput(e)}  onChange={ this.handleChange } required/>
							</div>
							
						</div>

					</div>

					<fieldset className="col-xs-12" style={{padding:"0"}}>
						<legend>Productos</legend>

						<div className="details form-group">
							<div className="col-xs-12 col-sm-2">
								<FormGroup id="valid_prod" validationState={this.state.valid_prod || null} 
									style={{marginBottom:"0px"}}>
									<span className="span-min">Producto</span>
									<Typeahead
							          	labelKey={(option) => (`${option.name}`)}
							          	minLength={0}
							          	options={this.state.products.length > 0 ? this.state.products : []}
							          	onChange={this.handleTypeAheadChange('product')}	
							            inputProps={{
							          		name:"product",
							          		id:"product",
							          		autoComplete:"off",
							          		required:true
							          	}}
							          	id="auto_product"
							          	isLoading={this.state.loading_product}
							          	useCache={false}
							          	ref={ref => this._typeahead_product = ref}
							          	defaultSelected={this.state.products.slice(this.state.index_product, 1)}
							          	selected={this.state.product_selected}
							          	selectHintOnEnter={true}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Cantidad</span>
								<input className="form-control" name="amount" id="amount" value={ this.state.amount } 
									onKeyPress={(e) => this.validateInput(e)} onChange={ this.handleChange } />
							</div>


							<div className="col-xs-12 col-sm-5">
								<span className="span-min">Observaciones</span>
								<input className="form-control" name="observations" value={ this.state.observations } 
									onChange={ this.handleChange } 
									onKeyPress={(e) => this.validateInput(e)} 
									className={"form-control"}/>
							</div>

							<div className="col-xs-12 col-sm-1">
								<FloatingActionButton className="action-btn" mini={true} style={{marginTop: 15 }} 
								onClick={this.addProduct}>
			                      <ContentAdd/>
			                    </FloatingActionButton> 
							</div>
						</div>

						<div className="col-xs-12"> 
			              <Table responsive hover style={{margin:"0px"}}>
			                <thead>
			                  <tr>
			                    <th>Producto</th>
			                    <th>Cantidad</th>
			                    <th>Observaciones</th>
			                    <th width={60}></th>
			                  </tr>
			                </thead>
			                <tbody>
			                 {this.state.tbl_products.map( (p, index) => (
			                    <tr key={index}>
			                      <td>{p.name}</td>
			                      <td>{p.amount}</td>
			                      <td>{p.observations} </td>
			                      <td width={60} style={{textAlign: "center",padding: "2px",}}>
			                        <Button className="btn btn-info btn-xs" title="Eliminar" 
			                        	style={{marginRight:'3px'}} 
			                        	onClick={(e) => this.removeUnitFromList(index, e)}>
			                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
			                        </Button>
			                      </td>
			                    </tr>
			                    ))}
			                </tbody>
			              </Table>
			            </div>
					</fieldset> 

			        <hr style={{width:"100%"}}/>
					<div className="col-xs-12" style={{textAlign:'center'}}>
			        	<div>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.submit')} primary={true} onClick={this.onSave.bind(this, 'enviar')}  style={{margin:12}}/>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave.bind(this, 'guardar')}  style={{margin:12}}/>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.reset')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
			        	</div>
			        </div>
							
				</form>

				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(PetitionPlasmaticForm);
